import { render, staticRenderFns } from "./IcnLater.vue?vue&type=template&id=97dda1f0&scoped=true"
import script from "./IcnLater.vue?vue&type=script&lang=js"
export * from "./IcnLater.vue?vue&type=script&lang=js"
import style0 from "./IcnLater.vue?vue&type=style&index=0&id=97dda1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dda1f0",
  null
  
)

export default component.exports